import angular from 'angular';
import '../core.module';

export const COMMAND_PALETTE_DETAILS = {
  'app.dashboard': {
    description: 'Visão geral do atendimento e das vendas',
    keywords: ['início', 'inicio', 'painel', 'home', 'visão geral', 'resumo']
  },
  'app.conversations': {
    description: 'Inbox de atendimento no WhatsApp',
    keywords: ['chat', 'mensagens', 'inbox', 'atendimento', 'whatsapp', 'caixa de entrada']
  },
  'app.contacts': {
    description: 'Base de clientes e leads',
    keywords: ['clientes', 'leads', 'pessoas', 'agenda de contatos']
  },
  'app.crm': {
    description: 'Funil de negócios em quadro kanban',
    keywords: ['funil', 'negócios', 'oportunidades', 'pipeline', 'kanban', 'deals']
  },
  'app.sales': {
    description: 'Pedidos, faturamento e desempenho de vendas',
    keywords: ['pedidos', 'vendas', 'faturamento', 'receita']
  },
  'app.sales.bookings': {
    shortcuts: [
      {
        label: 'Agenda de reservas',
        icon: 'calendar',
        description: 'Sessões e reservas agendadas',
        keywords: ['agenda', 'agendamentos', 'reservas', 'horários marcados', 'agenda de vendas']
      }
    ]
  },
  'app.sales.validation': {
    shortcuts: [
      {
        label: 'Validar entrada',
        icon: 'check-circle',
        description: 'Validar vouchers de passeios e ingressos por código ou QR Code',
        keywords: ['voucher', 'ingresso', 'check-in', 'entrada', 'qr code', 'validar', 'portaria']
      }
    ]
  },
  'app.payments': {
    description: 'Cobranças e recebimentos',
    keywords: ['cobranças', 'pix', 'recebimentos', 'transações', 'boleto'],
    shortcuts: [
      {
        label: 'Provedores de pagamento',
        icon: 'credit-card',
        params: { tab: 'provedores' },
        permission: 'payment.configure',
        description: 'Credenciais dos gateways de pagamento',
        keywords: ['gateway', 'adquirente', 'credenciais de pagamento']
      }
    ]
  },
  'app.products': {
    description: 'Catálogo de produtos e serviços',
    keywords: ['catálogo', 'catalogo', 'serviços', 'itens', 'ofertas']
  },
  'app.products.editor': {
    shortcuts: [
      {
        label: 'Novo produto ou serviço',
        icon: 'plus',
        params: { id: 'novo' },
        description: 'Cadastrar um item no catálogo',
        keywords: ['novo produto', 'cadastrar produto', 'criar produto', 'novo serviço']
      }
    ]
  },
  'app.products.settings': {
    shortcuts: [
      {
        label: 'Configurações do catálogo',
        icon: 'settings',
        description: 'Categorias e preferências de produtos',
        keywords: ['configurações de produtos', 'categorias', 'preferências do catálogo']
      }
    ]
  },
  'app.support': {
    description: 'Atendimentos de suporte',
    keywords: ['tickets', 'chamados', 'ajuda', 'sac']
  },
  'app.ai-agents': {
    description: 'Agentes de inteligência artificial',
    keywords: ['ia', 'inteligência artificial', 'assistente virtual', 'gpt'],
    shortcuts: [
      {
        label: 'Novo agente de IA',
        icon: 'plus',
        params: { acao: 'novo' },
        permission: 'ai_agent.create',
        description: 'Criar um agente de inteligência artificial',
        keywords: ['criar agente', 'novo assistente']
      },
      {
        label: 'Provedores de IA',
        icon: 'key',
        params: { tab: 'provedores' },
        permission: 'ai_agent.configure',
        description: 'Chaves e modelos dos provedores de IA',
        keywords: ['openai', 'chave de api', 'modelos de ia']
      }
    ]
  },
  'app.chatbots': {
    description: 'Fluxos automáticos de conversa',
    keywords: ['fluxos', 'bot', 'robô', 'robo', 'fluxo de conversa']
  },
  'app.automation': {
    description: 'Regras e gatilhos automáticos',
    keywords: ['gatilhos', 'regras', 'workflows']
  },
  'app.campaigns': {
    description: 'Disparos de mensagens em massa',
    keywords: ['disparos', 'envio em massa', 'marketing', 'broadcast']
  },
  'app.templates': {
    description: 'Modelos de mensagem aprovados',
    keywords: ['modelos', 'modelos de mensagem', 'hsm']
  },
  'app.quick-replies': {
    description: 'Mensagens prontas para o atendimento',
    keywords: ['respostas prontas', 'mensagens rápidas', 'atalhos de mensagem']
  },
  'app.teams': {
    description: 'Equipes e membros',
    keywords: ['vendedores', 'equipe', 'time', 'times', 'atendentes', 'membros']
  },
  'app.permissions': {
    description: 'Papéis e níveis de acesso',
    keywords: ['papéis', 'perfis de acesso', 'funções', 'cargos', 'acessos']
  },
  'app.numbers': {
    description: 'Números de WhatsApp conectados',
    keywords: ['whatsapp', 'telefones', 'instâncias', 'qr code', 'conectar número']
  },
  'app.reports': {
    description: 'Relatórios de atendimento e vendas',
    keywords: ['relatório', 'exportar', 'indicadores']
  },
  'app.analytics': {
    description: 'Métricas e gráficos de desempenho',
    keywords: ['métricas', 'gráficos', 'estatísticas', 'desempenho']
  },
  'app.connectors': {
    description: 'Canais e conexões de mensageria',
    keywords: ['canais', 'conexões', 'api oficial']
  },
  'app.connectors.create': {
    shortcuts: [
      {
        label: 'Novo conector',
        icon: 'plus',
        description: 'Conectar um novo canal',
        keywords: ['criar conector', 'adicionar canal', 'novo canal']
      }
    ]
  },
  'app.integrations': {
    description: 'Integrações com outros sistemas',
    keywords: ['apps', 'erp', 'sistemas externos']
  },
  'app.settings': {
    description: 'Empresa, usuários, horários, webhooks e preferências',
    keywords: [
      'preferências',
      'empresa',
      'conta',
      'usuários',
      'horários',
      'webhooks',
      'tema',
      'segurança',
      'sessões'
    ]
  },
  'app.audit': {
    description: 'Histórico de ações dos usuários',
    keywords: ['logs', 'histórico', 'registro de atividades', 'trilha']
  }
};

angular.module('app.core').constant('COMMAND_PALETTE_DETAILS', COMMAND_PALETTE_DETAILS);
